import { ColumnConfig } from '../hooks/useTablePreferences';

export const questionnaireColumns: ColumnConfig[] = [
  {
    key: 'type',
    label: 'Type',
    defaultWidth: 200,
    minWidth: 150,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'patientName',
    label: 'Patient',
    defaultWidth: 180,
    minWidth: 150,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'referralName',
    label: 'Referral',
    defaultWidth: 150,
    minWidth: 110,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'status',
    label: 'Status',
    defaultWidth: 120,
    minWidth: 100,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'sentDate',
    label: 'Sent Date',
    defaultWidth: 140,
    minWidth: 120,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'startDate',
    label: 'Start Date',
    defaultWidth: 140,
    minWidth: 120,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'finishDate',
    label: 'Finish Date',
    defaultWidth: 140,
    minWidth: 120,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'createdAt',
    label: 'Created',
    defaultWidth: 140,
    minWidth: 120,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'lastExit',
    label: 'Last Exit',
    defaultWidth: 150,
    minWidth: 120,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'exitLocation',
    label: 'Exit Location',
    defaultWidth: 200,
    minWidth: 150,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'lastSection',
    label: 'Last Section',
    defaultWidth: 220,
    minWidth: 150,
    visible: false,
    sortable: true,
    resizable: true,
    draggable: true,
  },
];

// Helper function to generate dynamic answer columns
export const generateDynamicAnswerColumns = (fieldNames: string[]): ColumnConfig[] => {
  return fieldNames.map((fieldName) => ({
    key: `answer_${fieldName}`,
    label: fieldName,
    defaultWidth: 150,
    minWidth: 100,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  }));
};

// Helper function to generate dynamic score columns
export const generateDynamicScoreColumns = (scoreNames: string[]): ColumnConfig[] => {
  return scoreNames.map((scoreName) => ({
    key: `score_${scoreName}`,
    label: `Score: ${scoreName}`,
    defaultWidth: 150,
    minWidth: 100,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  }));
};
